var React = require('react');
var ReactDom = require('react-dom');
var CartCount = require('../Views/Feature/Shop/CartCount/cartCount.jsx');
var defaultFetchOptions = require('~/../../src/Foundation/ReactForms/Code/Scripts/React/accountDataService.jsx').defaultFetchOptions;


var bootstrap = (isExperienceEditor) => {
    var fullUrl = "/api/reactforms/GetMemberStatusInfo";

    var instantiateReactElements = (isLoggedIn) => {
        $('.cartCount-react-root').each((index, node) => {
            ReactDom.render(
                <CartCount key={`cart-count-${index}`} isLoggedIn={isLoggedIn} />,
                node
            );
        });
    };

    //$(function () {
    //    instantiateReactElements();
    //});

    if (!isExperienceEditor) {
        fetch(fullUrl, defaultFetchOptions())
            .then((res) => {
                return res.json();
            })
            .then((result) => {
                var isLoggedIn = result && result.response && result.response.Data && result.response.Data.FirstName
                    ? true
                    : false;
                instantiateReactElements(isLoggedIn);
            },
                (error) => {
                    instantiateReactElements(false);
                });
    } else {
        instantiateReactElements(false);
    }
};

$(function () {
    if ($ && $(".scWebEditRibbon").length === 0) {
        bootstrap(false);
    } else {
        bootstrap(true);
    }
});